import * as coredev from './environment.coredev';
import * as local from './environment.local';
import * as production from './environment.production';
import * as rancher from './environment.rancher';
import * as staging from './environment.staging';
import * as test from './environment.test';

/**
 * contains the pilot pay environment configuration options
 */
export class Environment {
	public currentEnvironment(): string {
		let ppEnv: string = window.pilotPayEnvironment;
		if (!ppEnv) {
			ppEnv = 'local';
		}

		switch (ppEnv) {
			case 'prod':
			case 'production':
				return 'production';
			case 'rancher':
				return 'rancher';
			case 'coredev':
				return 'coredev';
			case 'dev':
			case 'test':
			case 'qa':
				return 'test';
			case 'staging':
				return 'staging';
			case 'local':
			default:
				return 'local';
		}
	}

	public isProduction(): boolean {
		const configuration: IEnvironmentConfiguration = this.getConfiguration();

		return configuration.isProduction;
	}

	public getConfiguration(): IEnvironmentConfiguration {
		const currentEnvironment: string = this.currentEnvironment();
		switch (currentEnvironment) {
			case 'production':
				return production.environmentConfiguration;
			case 'test':
				return test.environmentConfiguration;
			case 'staging':
				return staging.environmentConfiguration;
			case 'rancher':
				return rancher.environmentConfiguration;
			case 'local':
				return local.environmentConfiguration;
			case 'coredev':
				return coredev.environmentConfiguration;
			default:
				return null;
		}
	}
}

export interface IEnvironmentConfiguration {
	apiBasePath: string;
	isProduction: boolean;
	appInsightsKey?: string;
	frontendIdentityUrl: string;
	backendIdentityUrl: string;
	allowedEmailDomains: string[];
}

declare global {
	// tslint:disable-next-line:interface-name
	interface Window {
		pilotPayEnvironment: string;
	}
}
